<template>
  <div>
    <div
      v-if="screenWidth && sidebarOpen"
      class="sidebar-backdrop"
      @click="$emit('toggle-sidebar')"
    />
    <div
      id="toggle-animation"
      :class="{
        'card-sidebar': true,
        'sidebar-hidden': !sidebarOpen,
        'sidebar-visible': sidebarOpen,
        'sidebar-mobile': screenWidth,
      }"
    >
      <div class="sidebar uk-card uk-card-default uk-card-body uk-height-1-1">
        <div class="uk-flex uk-flex-center">
          <img
            class="simpan-logo uk-margin-bottom"
            :src="
              isShow ? `${images}/simpan_logo.png` : `${images}/simpan_logo.png`
            "
            alt=""
          >
          <a
            v-if="screenWidth"
            style="margin-top: 5px"
            class="header-link"
            @click.prevent="$emit('toggle-sidebar')"
          >
            <img
              :src="`${images}/icon/ic_close.svg`"
              alt="icon-close"
              class="uk-margin-medium-bottom"
            >
          </a>
        </div>

        <!-- Sidebar -->
        <ul
          v-if="isShow"
          id="sidebar"
          class="uk-nav-default uk-nav-parent-icon"
          uk-nav
        >
          <li
            v-for="items in filterSidebar"
            :key="items?.name"
            :class="getSidebarClass(items.routeName)"
            @click="
              items?.child?.length > 0 ? showSubMenu(items?.identifier) : ''
            "
          >
            <router-link
              :to="''"
              class="uk-flex uk-flex-between"
              @click.prevent="redirectMenu(items.identifier, items.to)"
            >
              <span>
                <img
                  :src="`${
                    items?.routeName?.split(', ').includes($route.name) > 0
                      ? images + '/icon/' + `${items.iconActive}.svg`
                      : images + '/icon/' + `${items.icon}.svg`
                  }`"
                  alt=""
                  class="sidebar-icon uk-margin-small-right"
                >
                {{ items.name }}
              </span>

              <span
                v-if="items?.child?.length > 0"
                class="uk-margin-small-left"
              >
                <img
                  :src="`${images}/icon/${
                    items.showChild
                      ? 'ic_chevron_up.svg'
                      : 'ic_chevron_down.svg'
                  }`"
                  alt=""
                  class="sidebar-icon"
                >
              </span>
            </router-link>
            <div
              v-if="items?.child?.length > 0"
              @click.stop
            >
              <ul
                class="uk-nav-sub sidebar-padding"
                :class="items.showChild ? '' : 'uk-hidden'"
              >
                <li
                  v-for="subItem in items?.child"
                  :key="subItem.name"
                  class="sidebar-padding-child"
                  :class="getSidebarClass(subItem.routeName)"
                >
                  <router-link
                    :key="subItem.name"
                    :to="''"
                    @click.prevent="redirectMenu(items.identifier, subItem.to)"
                  >
                    <span class="uk-margin-small-right child-active" />
                    {{ subItem.name }}
                  </router-link>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { PREFIX_IMAGE } from "@/utils/constant"
import sidebarJson from "./sidebar.json"
import employeeJson from "./employee.json"
import {
  getUserRole,
  getUserProfile,
  getUserRoleInfo,
  getUserEmployee
} from "@/utils/auth"

export default {
  props: {
    roleType: {
      required: true,
      type: String
    },
    sidebarOpen: {
      type: Boolean,
      default: false
    }
  },
  emits: ["toggle-sidebar"],
  data() {
    return {
      images: PREFIX_IMAGE,
      isShow: true,
      sidebar: sidebarJson,
      userRoleInfo: JSON.parse(getUserRoleInfo()),
      environment: process.env.VUE_APP_ENV === 'prod' ? 'production' : process.env.VUE_APP_ENV,
      screenWidth: false,
      userEmployeeData: getUserEmployee(),
      userProfileData: getUserProfile()
    }
  },
  computed: {
    user() {
      return this.userProfileData
    },
    userRole() {
      return getUserRole()
    },
    userEmployee() {
      return this.userEmployeeData
    },
    filterSidebar() {
      const isSuperAdmin = this.roleType === 'SUPER ADMIN' ||
        this.user?.role?.name?.toUpperCase() === 'SUPER ADMIN'
      const userRole = JSON.parse(getUserRole())
      const filterMenu = userRole.filter((item) => item?.view === true)

      return this.sidebar.map((item) => {
        const newItem = { ...item } // Create a copy to avoid mutation
        if (this.user?.role?.name != "user") {
          if (isSuperAdmin) {
            newItem["view"] = !this.environment || Boolean(newItem.showOn?.includes(this.environment))
          } else if (newItem?.child?.length > 0) {
            const siderChild = newItem.child.filter((y) => {
              const findChild = filterMenu.find((x) => x.menu === y.name)
              const menuView = findChild ? findChild.view : false
              if (menuView) return findChild
            })
            newItem.child = siderChild
            newItem["view"] = siderChild.length > 0 ? true : false
            if (newItem?.view) {
              if (this.environment) {
                if (!newItem.showOn?.includes(this.environment)) {
                  newItem["view"] = false
                }
              }
            }
          } else {
            const showMenuView = filterMenu.find(
              (x) => x.menu?.toUpperCase() === newItem.name?.toUpperCase()
            )
            const menuView = showMenuView ? showMenuView?.view : false
            if (menuView) {
              if (showMenuView?.menu?.toUpperCase() === "DATA CABANG") {
                const subdivision = this.userEmployee?.subdivision
                  ? true
                  : false
                if (subdivision) {
                  newItem["view"] = true
                } else {
                  newItem["view"] = false
                }
              } else {
                if (this.environment) {
                  if (newItem.showOn?.includes(this.environment)) {
                    newItem["view"] = true
                  } else {
                    newItem["view"] = false
                  }
                } else {
                  newItem["view"] = true
                }
              }
            } else {
              newItem["view"] = false
            }
          }
        } else {
          newItem["view"] = true
        }
        return newItem
      }).filter(item => item.view)
    },
    checkSidebarJson() {
      switch (this.roleType) {
      case "SUPER ADMIN" ||
          "ADMIN GENERAL" ||
          "ADMIN FINANCE" ||
          "ADMIN KLAIM" ||
          "ADMIN KEPESERTAAN":
        return sidebarJson
      case "COMPANY":
        return sidebarJson
      case "USER":
        return employeeJson
      default:
        return sidebarJson
      }
    }
  },
  watch: {
    $route() {
      this.expandActiveMenu()
    }
  },
  async mounted() {
    this.sidebar = this.checkSidebarJson
    this.expandActiveMenu()
    this.handleWidthScreen(screen?.width)
    window.addEventListener("resize", () => {
      this.handleWidthScreen(window.innerWidth)
    })
    await this.$store.dispatch("auth/getUserProfile")
    this.userEmployeeData = getUserEmployee()
    this.userProfileData = getUserProfile()
  },
  methods: {
    handleWidthScreen(value) {
      const width =
        typeof value === "number" ? value : value?.target?.innerWidth
      this.screenWidth = width <= 820
    },
    redirectMenu(identifier, path) {
      const companyId = this.user?.user_employee?.company?.id
      if (
        this.user?.role?.name?.toUpperCase() == "COMPANY" &&
        identifier?.toUpperCase() == "COMPANY" &&
        companyId
      ) {
        return this.$router.push({
          name: "CompanyDataEdit",
          params: { id: companyId }
        })
      }
      return this.$router.push(path)
    },
    expandActiveMenu() {
      const currentRoute = this.$route.name
      this.sidebar = this.sidebar.map((item) => {
        if (item?.child?.length > 0) {
          const hasActiveChild = item.child.some((child) =>
            child.routeName?.split(", ").includes(currentRoute)
          )
          if (hasActiveChild) {
            return { ...item, showChild: true }
          }
        }
        return item
      })
    },
    showSubMenu(identifier) {
      this.sidebar = this.sidebar.map((item) => {
        if (item.identifier === identifier) {
          return {
            ...item,
            showChild: !item.showChild
          }
        }
        return item
      })
    },
    getParentPath(fullPath) {
      const path = fullPath.split("/").filter((path) => path !== "")
      let splitPath = path[path.length - 2]
      return splitPath
    },
    getSidebarClass(routeName) {
      return {
        active: routeName?.split(", ").includes(this.$route.name) > 0,
        inactive: routeName?.split(", ").includes(this.$route.name) < 1
      }
    }
  }
}
</script>

<style scoped>
#toggle-animation {
  transition: transform 300ms ease;
}
.sidebar-hidden:not(.sidebar-mobile) {
  display: none;
}
.sidebar-mobile.sidebar-hidden {
  transform: translateX(-100%);
  pointer-events: none;
}
.sidebar-mobile.sidebar-visible {
  transform: translateX(0);
  pointer-events: auto;
}
.sidebar-mobile {
  position: fixed;
  top: 0;
  left: 0;
  width: 280px;
  height: 100vh;
  z-index: 100;
  box-shadow: 4px 0 12px rgba(0, 0, 0, 0.15);
}
.sidebar-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  z-index: 99;
}
.sidebar {
  background-color: #ffffff;
  overflow: auto;
}
.sidebar-icon {
  width: 24px;
  height: 24px;
}
.simpan-logo {
  width: 205px;
  height: 80px;
}
.uk-nav-default > li > a {
  font-weight: 600;
  font-size: 14px;
  color: #8592ad;
}
.parent-text {
  font-family: "Poppins";
  font-size: 14px;
  font-weight: 600;
}
.sidebar-padding {
  padding-left: 0px !important;
}
.sidebar-padding-child {
  font-weight: 600;
  height: 56px !important;
  display: flex !important;
  padding: 0 0 0 40px !important;
  border-left: none !important;
}
.child-active {
  width: 0;
  height: 56px;
  margin-right: 22px !important;
  margin-left: 12px !important;
  border: 0.75px dashed #004fa4;
  border-left: none !important;
}
li {
  padding: 14px 0;
}
.uk-nav-header {
  color: #fff;
}
.uk-nav-default li a.just-icon {
  padding: 0;
  text-align: center;
}
.active {
  background: linear-gradient(
    90deg,
    rgba(0, 117, 255, 0.1) 0%,
    rgba(0, 117, 255, 0) 117.12%
  );
  color: #004fa4;
  border-left: 3px solid #004fa4;
}
.active > a {
  color: #004fa4 !important;
}
.uk-nav-default .uk-nav-sub a {
  color: #8592ad;
}
.uk-nav-default > li > a:hover,
.uk-nav-default > li > a:focus {
  color: #558cc7;
}
.uk-parent.uk-open {
  background: transparent;
  color: #8592ad;
  border-left: none;
}
.uk-nav-parent-icon > .uk-parent.uk-open > a::after {
  transform: rotate(180deg);
}
</style>
